module.exports = __webpack_public_path__ + "media/images/hydro_dam-1c586bedd6b6196c6e865df599c7ea97.png";